export function logInfo(scope, message, meta = {}) {
  console.info(`[INFO][${scope}] ${message}`, meta);
}

export function logWarn(scope, message, meta = {}) {
  console.warn(`[WARN][${scope}] ${message}`, meta);
}

export function logError(scope, message, error, meta = {}) {
  console.error(`[ERROR][${scope}] ${message}`, {
    errorMessage: error?.message || null,
    errorCode: error?.code || null,
    stack: error?.stack || null,
    ...meta
  });
}
